<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          v-for="(item, i) in filteredCategories"
          :key="i"
          class="py-6 px-md-6"
          cols="12"
          md="6"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.name}`"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catContact",

  components: { CatCard },

  data: () => ({
    serviceName: "Qrland",
    componentName: "catContact",
    helpData: [],
  }),
  computed: {
    categories() {
      return [
        {
          name: this.$t("categories.catalog"),
          value: "",
          route: "qr.catalog",
          colors: ["#0093E9", "#80D0C7", "#0093E9"],
          icon: "mdi-notebook",
          isTest: false,
        },
        {
          name: this.$t("categories.discount_code"),
          value: "",
          route: "qr.link",
          colors: ["#93291E", "#ED213A", "#93291E"],
          icon: "mdi-sale",
          comingSoon: true,
        },
        {
          name: this.$t("categories.faq"),
          value: "",
          route: "qr.link",
          colors: ["#2c3e50", "#2980b9", "#2c3e50"],
          icon: "mdi-help",
          comingSoon: true,
        },
        {
          name: this.$t("categories.feedback_survey"),
          value: "",
          route: "qr.link",
          colors: ["#6a3093", "#a044ff", "#6a3093"],
          icon: "mdi-comment-quote",
          comingSoon: true,
        },
        {
          name: this.$t("categories.consultation_request"),
          value: "",
          route: "qr.link",
          colors: ["#e43a15", "#e65245", "#e43a15"],
          icon: "mdi-handshake",
          comingSoon: true,
        },
        {
          name: this.$t("categories.customer_club"),
          value: "",
          route: "qr.link",
          colors: ["#FF8008", "#FFC837", "#FF8008"],
          icon: "mdi-face-agent",
          comingSoon: true,
        },
      ];
    },
    filteredCategories() {
      const currentLocale = this.$i18n.locale;
      if (currentLocale === "fa") {
        return this.categories;
      }
      return this.categories.map((x) => ({ ...x, comingSoon: true }));
      // return this.categories.filter(
      //   (item) => item.name === this.$t("categories.electronic_business_card")
      // );
    },
  },

  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
